import React from "react";
import { ExternalLink } from "lucide-react";
import { trackEvent } from "../lib/analytics";

export const InstructionsSection = ({ selectedExam }) => {
    const hasExam = !!selectedExam;
    const bookUrl = selectedExam?.bookUrl || "#";
    const ctaLabel = selectedExam
        ? `Book ${selectedExam.name}`
        : "Select an exam to continue";

    const handleBookingClick = () => {
        if (!selectedExam) return;
        trackEvent("booking_click", {
            surface: "main",
            exam_id: selectedExam.id,
        });
    };

    return (
        <section
            id="instructions"
            data-testid="instructions-section"
            className="max-w-3xl mx-auto px-6 sm:px-8 py-20 sm:py-24"
        >
            <div className="text-center">
                <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#D32F2F]">
                    How it works
                </span>
                <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-[#0A1128] font-[Outfit]">
                    Use your code in 2 steps
                </h2>
            </div>

            <ol className="mt-14 space-y-8 max-w-xl mx-auto text-left">
                <li
                    data-testid="instruction-step-1"
                    className="flex gap-5 items-start"
                >
                    <span className="flex-shrink-0 w-11 h-11 rounded-full bg-[#1B2A47] text-white font-semibold flex items-center justify-center font-[Outfit]">
                        1
                    </span>
                    <div className="pt-2">
                        <p className="text-base sm:text-lg font-medium text-[#0A1128]">
                            Choose your LanguageCert exam
                        </p>
                    </div>
                </li>
                <li
                    data-testid="instruction-step-2"
                    className="flex gap-5 items-start"
                >
                    <span className="flex-shrink-0 w-11 h-11 rounded-full bg-[#1B2A47] text-white font-semibold flex items-center justify-center font-[Outfit]">
                        2
                    </span>
                    <div className="pt-2">
                        <p className="text-base sm:text-lg font-medium text-[#0A1128]">
                            Enter the code during booking
                        </p>
                    </div>
                </li>
            </ol>

            <div className="mt-14 flex flex-col items-center">
                {hasExam ? (
                    <a
                        href={bookUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleBookingClick}
                        data-testid="booking-cta-button"
                        className="inline-flex items-center justify-center gap-2 bg-[#D32F2F] hover:bg-[#B71C1C] text-white px-8 py-3.5 rounded-md font-medium text-sm transition-all shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D32F2F] focus-visible:ring-offset-2 active:scale-[0.98]"
                    >
                        {ctaLabel}
                        <ExternalLink className="w-4 h-4" />
                    </a>
                ) : (
                    <button
                        type="button"
                        disabled
                        data-testid="booking-cta-button-disabled"
                        className="inline-flex items-center justify-center gap-2 bg-[#E2E8F0] text-[#64748B] px-8 py-3.5 rounded-md font-medium text-sm cursor-not-allowed"
                    >
                        {ctaLabel}
                    </button>
                )}
                <p className="mt-3 text-xs text-[#64748B]">
                    Booking opens in a new tab.
                </p>
            </div>
        </section>
    );
};

export default InstructionsSection;
